import { render, staticRenderFns } from "./CowsImportPurchaseForm.vue?vue&type=template&id=7d87a509&scoped=true&"
import script from "./CowsImportPurchaseForm.vue?vue&type=script&lang=js&"
export * from "./CowsImportPurchaseForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d87a509",
  null
  
)

export default component.exports